import { useContext } from "react";
import { HOST } from "../constants/HostConstants";
import { AlertContext } from "../context/MainContext";

export const advertisementByUser = async (user_id, { setAdvertisement }) => {
  fetch(`${HOST}/api/advertisement/advertisementByUser`, {
    method: "POST",
    body: JSON.stringify({
      user_id,
    }),
    credentials: "include",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      setAdvertisement(data);
    });
};
